var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaintPallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.571 8.571a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428Zm-6.857 8.572a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714Zm0-6a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32 21.052a1.715 1.715 0 0 0-1.114-1.51 3.429 3.429 0 0 1 1.08-6.685h3.205a3.428 3.428 0 0 0 3.24-4.577 11.143 11.143 0 1 0-10.508 14.863 10.802 10.802 0 0 0 2.983-.412 1.543 1.543 0 0 0 1.114-1.68Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaintPallet);
export default __webpack_public_path__ + "static/media/icon_paint_pallet.ab2796db4369c8f05fc95048618cfb21.svg";
export { ForwardRef as ReactComponent };